import { Model } from './Model';

export interface DocumentType {
    id: number;
    mime_type: string;
    extension: string;
    size: number;
    file_path: string;
    thumbnail_path: string;
    image40: string;
    image125: string;
    image400: string;
    file_name: string;
    link: string;
    media_type: string;
    document_type: string;
    resource_type: string;
}

export const Document = Model<DocumentType>('Document', {
    endpoint: 'documents',
})`
    id:Int;
    mime_type:String;
    extension:String;
    size:Int;
    file_path:String;
    thumbnail_path:String;
    image40:String;
    image125:String;
    image400:String;
    file_name:String;
    link:String;
    media_type:String;
    document_type:String;
    resource_type:String;
`;

export const INPUT_ACCEPT_IMAGE = ['image/*'];

export const INPUT_ACCEPT = [
    '.pdf',
    '.doc',
    '.docx',
    '.xls',
    '.xlsx',
    '.csv',
    'text/plain',
    'application/msword',
    'application/msexcel',
    'application/vnd.ms-word',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];

export enum DOCUMENT_TYPE {
    IMAGE = 'Wooter\\Image',
    VIDEO = 'Wooter\\Video',
    DOCUMENT = 'Wooter\\Document',
}
